import { TextSectionTableRecord } from "src/__generated__/cms-schema.codegen";
import { getIcon } from "src/components/CMSButton/CMSButtonLabel";
import { DatoAsset } from "src/components/Dato/DatoAsset";
import { HeadingLevelBoundary, Hx } from "src/components/Heading/Heading";

type TableProps = TextSectionTableRecord;

export const Table: React.FC<TableProps> = ({ columns }) => {
	return (
		<HeadingLevelBoundary>
			<div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 text-brand-blue justify-items-start py-12">
				{columns.map(({ id, icon, heading, items }) => (
					<div key={id} className="text-start">
						<div className="flex items-center gap-2.5">
							{icon && (
								<DatoAsset
									data={icon}
									className="size-[3.75rem]"
								/>
							)}
							<Hx size="h4" className="!m-0 py-6">
								{heading}
							</Hx>
						</div>
						<div className="flex flex-col gap-6 py-6">
							{items.map((item) => (
								<div
									key={item.id}
									className="flex gap-2 items-start"
								>
									<span className="text-brand-highlight">
										{getIcon(item.icon.name, {
											className: "!w-6 !h-6",
										})}
									</span>
									<span>{item.text}</span>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		</HeadingLevelBoundary>
	);
};

// 🔬 covered by story
